/**
 * Created by luka on 28.02.2018.
 */
import React from 'react';

import {colors} from "../styles/colors";
import {CircularProgress} from 'material-ui/Progress';
import IconButton from 'material-ui/IconButton';
import Refresh from 'material-ui-icons/Refresh';

export default class WorkoutButton extends React.PureComponent {
    onPress = () => {
        this.props.onReload();
    };

    render() {
        return (
                <IconButton color="inherit" onClick={() => this.onPress()}>
                    {this.props.loading === false &&
                    <Refresh/>}

                    {this.props.loading &&
                    <CircularProgress color='secondary' size={24} style={styles.progress}/>}
                </IconButton>
        )
    }
}

const styles = ({
    progress: {
        color: colors.white
    },
});




// WEBPACK FOOTER //
// ./src/components/Reload.js